import React from 'react'
import "./Contact.css"
import FacebookIcon from "@material-ui/icons/Facebook"
import GithubIcon from "@material-ui/icons/GitHub"
import TwitterIcon from "@material-ui/icons/Twitter"
import LinkedInIcon from "@material-ui/icons/LinkedIn"
function Contact() {
    return (
        <div className="contact">
            <h1>contact</h1>
            <div className="contact_socialMediaIcons">
                <FacebookIcon className="sociIcon" />
                <GithubIcon className="sociIcon"  />
                <TwitterIcon className="sociIcon"  />
                <LinkedInIcon className="sociIcon"  />
            </div>
        </div>
    )
}

export default Contact
